import { render, staticRenderFns } from "./my-business-renewal-orders.vue?vue&type=template&id=1969f1bf&scoped=true"
import script from "./my-business-renewal-orders.vue?vue&type=script&lang=js"
export * from "./my-business-renewal-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1969f1bf",
  null
  
)

export default component.exports